import {makeStyles} from "@material-ui/core";
import {Colors} from "../../styles/Colors";

export const useStyles = makeStyles(() => ({
    mainDashboardContainer: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: "column",
        background: Colors.White,
        overflow: 'hidden',
        position: 'relative',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 'calc(100% - 96px - 12px)',
        padding: '24px 12px 24px 96px'
    },
    rightSection:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center'
    },
    dashboardContentContainer: {
        width: 'calc(100% - 96px)',
        flex: 1,
        overflow: 'auto',
        background: '#F9F9F9',
        padding: '48px 0px 0px 96px',
        display: 'flex',
        flexDirection: 'row',
        overflowY: 'hidden'
    },
    dashboardLeftPart: {
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'hidden',
        overflowY: 'auto',
        height: 'fit-content',
        maxHeight: 'calc(100vh - 110px - 16px - 24px)',
        width: 480,
    },
    dashboardRightPart: {
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'hidden',
        overflowY: 'auto',
        height: 'fit-content',
        maxHeight: 'calc(100vh - 110px - 16px - 24px)',
        width: 'calc(100% - 480px - 24px)'
    },
}));